import {
  BoardBackground,
  DarkModeUITheme,
  LightModeUITheme,
  Preferences,
  ThemeMode,
  TokenStyle,
} from "./preferences";

export const initialPreferences: Preferences = {
  theme: {
    [ThemeMode.Dark]: DarkModeUITheme.ClassicDark,
    [ThemeMode.Light]: LightModeUITheme.ClassicLight,
  },
  themeMode: ThemeMode.System,
  tokenStyle: TokenStyle.Classic,
  boardBackground: BoardBackground.Classic,
};
